import LegalLayout from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      testId="privacy-page"
      eyebrow="Legal"
      title="Privacy Policy"
      updated="February 2026"
    >
      <section>
        <h2>1. Who We Are</h2>
        <p>
          <strong>JUKE TRANSFERS j.d.o.o.</strong> (OIB: 05308456115), Mosećka ul. 34, 21000
          Split, Croatia, is the data controller for personal information collected through this
          website and during the booking process.
        </p>
      </section>

      <section>
        <h2>2. What We Collect</h2>
        <p>
          We only collect the information strictly needed to plan and deliver your transfer:
        </p>
        <ul>
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Pickup and drop-off address, date and time, passenger and luggage count</li>
          <li>Flight number and airline (only when relevant for airport transfers)</li>
          <li>Any special instructions you choose to add in the notes field</li>
        </ul>
        <p>
          We do not collect payment card numbers on our own servers. If a deposit is required,
          payment is processed by a PCI-DSS compliant provider.
        </p>
      </section>

      <section>
        <h2>3. How We Use Your Data</h2>
        <p>
          Your data is used <strong>exclusively for booking and transfer logistics</strong>:
        </p>
        <ul>
          <li>Confirming and coordinating your transfer with your assigned driver.</li>
          <li>Sending booking confirmations, reminders, and receipts by email.</li>
          <li>Tracking your flight (via a licensed flight-data provider) to time the pickup.</li>
          <li>Contacting you by phone or WhatsApp on the day of the transfer if needed.</li>
          <li>Fulfilling our legal obligations (invoicing, tax records) under Croatian law.</li>
        </ul>
        <p>
          We do <strong>not</strong> sell, rent, or share your personal data with third parties
          for marketing purposes.
        </p>
      </section>

      <section>
        <h2>4. Security</h2>
        <p>
          Your data is transmitted over encrypted HTTPS connections and stored in a secured
          database with access restricted to authorised staff on a need-to-know basis. Backups
          are encrypted at rest. Passwords for internal systems are hashed using industry-standard
          algorithms.
        </p>
      </section>

      <section>
        <h2>5. Retention</h2>
        <p>
          Booking records are retained for as long as required by Croatian bookkeeping and tax
          law (currently 11 years). Marketing communications, where you have explicitly opted in,
          can be unsubscribed from at any time.
        </p>
      </section>

      <section>
        <h2>6. Your GDPR Rights</h2>
        <p>Under the EU General Data Protection Regulation, you have the right to:</p>
        <ul>
          <li>Access the personal data we hold about you.</li>
          <li>Request correction of inaccurate data.</li>
          <li>Request deletion of your data (subject to legal retention obligations).</li>
          <li>Object to or restrict processing.</li>
          <li>Request a copy of your data in a portable format.</li>
          <li>Lodge a complaint with the Croatian Personal Data Protection Agency (AZOP).</li>
        </ul>
      </section>

      <section>
        <h2>7. Cookies</h2>
        <p>
          This website uses a small number of essential cookies to make the site work (e.g. your
          language preference) and optional analytics cookies to help us understand how visitors
          use the site. You can accept or reject non-essential cookies via the cookie banner on
          your first visit. Rejecting non-essential cookies will not affect your ability to book
          a transfer.
        </p>
      </section>

      <section>
        <h2>8. Contact</h2>
        <p>
          To exercise any of your rights, or if you have any questions about how we handle your
          data, contact us at{" "}
          <a href="mailto:bookings@juketransfers.hr" className="text-[#C5A059] hover:text-[#D4AF37] underline underline-offset-2">bookings@juketransfers.hr</a>.
        </p>
      </section>
    </LegalLayout>
  );
}
